module.exports = __webpack_public_path__ + "img/square_1.894c20e0.png";